import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'product-detail',
  name: '商品详情',
  icon: '详',
  group: '商品详情页',
  description: '商品图文详情、参数和使用说明',
  defaultProps: {
    title: '商品详情',
    html: '<p>商品详情由商品数据和装修内容共同组成</p>'
  }
}
